import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Table } from '@vwfs-bronson/bronson-react';
import { getLeasingDocumentsList } from '../../../../../services/api/miles/central-document-handling';
import { LeasingDocument } from '../../../../../services/api/miles/types';
import { store } from '../../../../../services/redux';
import { loadingActions } from '../../../../../services/redux/features/loading.slice';
import { useNavigate } from '../../../../../services/routing/navigate';
import {
  DashboardSubpageDocumentsEntityType,
  DashboardSubpageDocumentsSourceType,
} from '../../DashboardSubpageDocuments/DashboardSubpageDocuments';
import { DashboardDocumentLeasingDocumentTableRow } from './DashboardDocumentLeasingDocumentTableRow';

export interface DashboardDocumentLeasingDocumentsTableProps {
  selectedId: string;
  transactionId: string;
  sourceType: DashboardSubpageDocumentsSourceType;
  entityType: DashboardSubpageDocumentsEntityType;
}

export const DashboardDocumentLeasingDocumentsTable: FunctionComponent<DashboardDocumentLeasingDocumentsTableProps> = ({
  selectedId,
  transactionId,
  entityType,
  sourceType,
}) => {
  const { t } = useTranslation();
  const [documentTemplatesList, setDocumentTemplatesList] = useState<Array<LeasingDocument>>();
  const navigate = useNavigate();

  useEffect(
    function getDocumentList() {
      const fetchTemplates = async () => {
        if (selectedId) {
          store.dispatch(loadingActions.setLoading(true));
          const data = await getLeasingDocumentsList(
            selectedId,
            sourceType,
            DashboardSubpageDocumentsEntityType.LEASING_DOCUMENTS
          );
          setDocumentTemplatesList(data.documents);

          store.dispatch(loadingActions.setLoading(false));

          return data;
        }

        throw new Error(`Can't fetch template list for id: ${selectedId}`);
      };

      fetchTemplates().catch(() => {
        store.dispatch(loadingActions.setLoading(false));
        navigate.error();
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedId]
  );

  return (
    <>
      {documentTemplatesList && documentTemplatesList.length > 0 ? (
        <Table>
          <Table.Tbody>
            {documentTemplatesList?.map((document) => {
              return (
                <DashboardDocumentLeasingDocumentTableRow
                  documentName={typeof document.label === 'string' ? document.label : document.label?.translation}
                  documentId={document.id}
                  selectedId={selectedId || ''}
                  key={document.id}
                  entityType={entityType}
                  sourceType={sourceType}
                  transactionId={transactionId}
                />
              );
            })}
          </Table.Tbody>
        </Table>
      ) : (
        <Heading className="u-text-center" level={5}>
          {t('dashboardSubpageDocuments:listContainer:emptyList')}
        </Heading>
      )}
    </>
  );
};
